import { render, staticRenderFns } from "./BookingFieldBoolean.vue?vue&type=template&id=20602120&scoped=true"
import script from "./BookingFieldBoolean.vue?vue&type=script&lang=js"
export * from "./BookingFieldBoolean.vue?vue&type=script&lang=js"
import style0 from "./BookingFieldBoolean.vue?vue&type=style&index=0&id=20602120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20602120",
  null
  
)

export default component.exports